import {
  CreateUpdateEstimateItemDto,
  ProfileSchemaDto,
} from '../../../../common/pokCore/autogenerated/pokApiClient';

import { calculatePurchaseFields } from './purchaseCalculator';
import { calculateSalesFields } from './salesCalculator';

export const calculateFields = (
  obj: Partial<CreateUpdateEstimateItemDto>,
  schema: ProfileSchemaDto | undefined,
  item: CreateUpdateEstimateItemDto,
) => {
  obj = calculateSalesFields(obj, schema, item);
  obj = calculatePurchaseFields(obj, schema, item);
  return obj;
};
